import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const healthsafety = {
  getCategoryChart,
  getDataTypePolicy,
  getDataActivity,
  storeOrUpdateActivityPolicies,
  destroyActivity,
  getActivityPolicyByProperty,
  getHealthAndSafetyAssets,
  trafficLight,
  search,
  getDashboard,
  getSafetyDocuments,
  getSafetyDocumentAssets
};

// Safety Documents browser — categories (tags) with the count of tagged assets.
// The controller returns HTTP 200 for its error paths too (e.g. "Access denied"
// carries code=request_invalid), so a non-0000 code must REJECT — otherwise the
// caller's .catch never fires and a refusal renders as an empty result.
function getSafetyDocuments(propertyId, corporateGroupId){
  const params = new URLSearchParams();
  if (corporateGroupId) params.append('corporate_group_id', corporateGroupId);
  else if (propertyId) params.append('property_id', propertyId);
  return axios
    .get(`${apiEndpoint.healthSafety}/safety-documents?${params.toString()}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data && res.data.code === '0000') { return res.data; }
      throw new Error((res && res.data && res.data.message) || 'Request failed');
    });
}

// The tagged assets for one category, each with its attachments.
function getSafetyDocumentAssets(type, propertyId, corporateGroupId, page, perPage, search){
  const params = new URLSearchParams({ type });
  if (corporateGroupId) params.append('corporate_group_id', corporateGroupId);
  else if (propertyId) params.append('property_id', propertyId);
  if (page) params.append('page', page);
  if (perPage) params.append('per_page', perPage);
  if (search) params.append('search', search);
  return axios
    .get(`${apiEndpoint.healthSafety}/safety-document-assets?${params.toString()}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data && res.data.code === '0000') { return res.data; }
      throw new Error((res && res.data && res.data.message) || 'Request failed');
    });
}

function getDashboard(propertyId, from, to){
  const params = new URLSearchParams({ property_id: propertyId });
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  return (
    axios
      .get(
        `${apiEndpoint.healthSafety}/dashboard?${params.toString()}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data && res.data.code === '0000'){
          return res.data;
        }
        throw new Error((res && res.data && res.data.message) || 'Request failed');
      })
  );
}

function getCategoryChart(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.getCategoryChart}?propertyId=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.attachments(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}
function destroyActivity(id){
  return (
    axios
      .delete(
        apiEndpointFunction.activityPolicies(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function getDataActivity(facilitiesId){
  return (
    axios
      .get(
        `${apiEndpoint.activityPolicies}?facilitiesId=${facilitiesId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );

}
function getDataTypePolicy(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.getDataTypePolicy}?propertyId=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdateActivityPolicies(data,id = null){
    return (id ? (
    axios
      .put(
        apiEndpointFunction.activityPolicies(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.activityPolicies,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function getActivityPolicyByProperty(propertyId){
  return (
    axios
      .get(
        `${apiEndpointFunction.activityPolicies(propertyId)}/get-activity-policy-by-property`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getHealthAndSafetyAssets(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.facilities}/get-health-and-safety-assets?propertyId=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function search(propertyId,s){
  return (
    axios
      .get(
        `${apiEndpoint.healthSafety}/search?property_id=${propertyId}&s=${s}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function trafficLight(propertyId){
  return (
    axios
      .get(
        `${apiEndpointFunction.activityPolicies(propertyId)}/traffic-light`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}